// extracted by mini-css-extract-plugin
export default {"authBtn":"styles_authBtn__CUXtM"};